"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const CodeInfo = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 24,
  height: 24,
  viewBox: "-1 1 24 22"
}, props), _react.default.createElement("path", {
  className: "fill",
  d: "M17.5 12c3.032 0 5.5 2.469 5.5 5.5 0 3.033-2.468 5.5-5.5 5.5a5.506 5.506 0 0 1-5.5-5.5c0-3.031 2.467-5.5 5.5-5.5zm.917 5.5h-1.834v3.667h1.834V17.5zM13.924 2L18 5.96v4.677a7.207 7.207 0 0 0-4.356 1.457l-1.238-1.202-1.257 1.221 1.238 1.202a6.75 6.75 0 0 0-1.498 4.231c0 1.26.352 2.437.959 3.454h-8.07C2.798 21 2 20.225 2 19.273V3.727C2 2.775 2.797 2 3.778 2h10.146zm-6.33 8.892l-3.295 3.202 3.295 3.201 1.257-1.221-2.039-1.98 2.039-1.98-1.257-1.222zm9.906 3.852a.917.917 0 1 0 0 1.834.917.917 0 0 0 0-1.834zm-4.833-11.88v4.318h4.444l-4.444-4.318z",
  fill: "none",
  fillRule: "evenodd"
}));

var _default = CodeInfo;
exports.default = _default;